import * as definitions from 'store/definitions/category';

export function fetchCategories(filter) {
  return {
    type: definitions.FETCH_CATEGORIES,
    payload: filter,
  };
}

export function fetchCategory(id) {
  return {
    type: definitions.FETCH_CATEGORY,
    payload: id,
  };
}

export function createCategory(data, image) {
  return {
    type: definitions.CREATE_CATEGORY,
    payload: { data, image },
  };
}

export function updateCategory(data, image) {
  return {
    type: definitions.UPDATE_CATEGORY,
    payload: { data, image },
  };
}
